import React from 'react';
import styled from 'styled-components';

import { BaseButton } from 'src/components/kiosk-pro/kiosk-pro-layout/consumer-info/consumer-info.styles';
import { useKioskPro } from 'src/hooks/use-kiosk-pro';
import useUser from 'src/hooks/use-user';
import { useKioskProLayout } from 'src/components/kiosk-pro/kiosk-pro-layout/use-kiosk-pro-layout';
import useDispensary from 'src/dispensary/hooks/use-dispensary';
import useUI from 'src/hooks/use-ui';
import CartEmptyState from 'src/components/empty-loading-state/empty-page-states/cart-empty-state';

export const KioskLoggedOutEmptyCart = (): JSX.Element => {
  const { closeCartDrawer } = useUI();
  const isKioskPro = useKioskPro();
  const { isLoggedIn } = useUser();
  const { dispensary } = useDispensary();
  const { kioskProModalLogin } = useKioskProLayout({ dispensary });

  const handleLoginClick = (): void => {
    void kioskProModalLogin();
    closeCartDrawer();
  };

  // If Kiosk Pro is enabled and the user is logged out, show the QR code login button
  if (isKioskPro && !isLoggedIn) {
    return <KioskLoginButton onClick={handleLoginClick}>Login</KioskLoginButton>;
  }

  return <CartEmptyState onClose={closeCartDrawer} />;
};

const KioskLoginButton = styled(BaseButton)`
  margin-top: 24px;
  display: block;
`;
